import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const DELETE_QUOTE_RESET = 'DELETE_QUOTE_RESET';
export const DELETE_QUOTE_LOADING = 'DELETE_QUOTE_LOADING';
export const DELETE_QUOTE_SUCCESS = 'DELETE_QUOTE_SUCCESS';
export const DELETE_QUOTE_REJECT = 'DELETE_QUOTE_REJECT';

//* ACTIONS ------------------------------------------------
export const deleteQuoteReset = () => ({ type: DELETE_QUOTE_RESET });
export const deleteQuoteLoading = () => ({ type: DELETE_QUOTE_LOADING });
export const deleteQuoteSuccess = (payload) => ({ type: DELETE_QUOTE_SUCCESS, payload });
export const deleteQuoteReject = (payload) => ({ type: DELETE_QUOTE_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const deleteQuoteRequest = async (data = {}, getState) => {
    const options = await withToken({
        method: Methods.DELETE,
        data,
    }, getState);
    return request(`/api/Quote/${data.id}`, options);
};